export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Schiltigheim
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Schiltigheim est la ville la plus dense du Bas-Rhin après Strasbourg. Entre les immeubles collectifs et les maisons de ville, les fenêtres subissent une sollicitation intense. Nos techniciens réparent le mécanisme sur place, pièce comprise, sans remplacer toute la fenêtre.
            </p>
            <p>
              Schiltigheim, à la porte de Strasbourg, est un maillage dense d'immeubles, de maisons de ville et de résidences collectives. Les fenêtres y subissent une usure quotidienne intense : le vent, les variations de température, les ouvertures répétées. Nos techniciens connaissent les quartiers de Schiltigheim et interviennent à domicile pour réparer la pièce défectueuse.
            </p>
            <p>
              Situé à quelques minutes, notre atelier nous permet de répondre souvent le jour même. Le déplacement est gratuit dans tout le Bas-Rhin, le diagnostic est gratuit et chaque pièce remplacée est garantie 10 ans. Nous emportons un stock de pièces adaptées aux mécanismes les plus courants rencontrés dans les logements de Schiltigheim.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}